import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import HelloWorld from '@/components/HelloWorld';
import Index from '@/components/Index';
import ApplyRequest from '@/components/ApplyRequest';
import GaoYaLogin from  '@/components/GaoYa/Login';
import GaoYaIndex from '@/components/GaoYa/LabIndex';
import GaoYaHall from '@/components/GaoYa/LabHall';
import GaoYaUpgrade from '@/components/GaoYa/LabUpgrade';
import GaoYaTeach from '@/components/GaoYa/LabTeach';
import GaoYaPerson from '@/components/GaoYa/LabPerson';
import GaoYaCenter from '@/components/GaoYa/LabCenter';
import ReLiXueLogin from  '@/components/ReLiXue/Login';
import ReLiXueIndex from '@/components/ReLiXue/LabIndex';
import ReLiXueHall from '@/components/ReLiXue/LabHall';
import ReLiXueUpgrade from '@/components/ReLiXue/LabUpgrade';
import ReLiXueTeach from '@/components/ReLiXue/LabTeach';
import ReLiXuePerson from '@/components/ReLiXue/LabPerson';
import ReLiXueEMB01 from '@/components/ReLiXue/LabEMB01';
import ReLiXueEMB02 from '@/components/ReLiXue/LabEMB02';

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/hello',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/apply',
      name: 'ApplyRequest',
      component: ApplyRequest
    },
    {
      path: '/gaoya/login',
      name: 'GaoYaLogin',
      component: GaoYaLogin
    },
    {
      path: '/gaoya/index',
      name: 'GaoYaIndex',
      component: GaoYaIndex
    },
    {
      path: '/gaoya/hall',
      name: 'GaoYaHall',
      component: GaoYaHall
    },
    {
      path: '/gaoya/upgrade',
      name: 'GaoYaUpgrade',
      component: GaoYaUpgrade
    },
    {
      path: '/gaoya/teach',
      name: 'GaoYaTeach',
      component: GaoYaTeach
    },
    {
      path: '/gaoya/person',
      name: 'GaoYaPerson',
      component: GaoYaPerson
    },
    {
      path: '/gaoya/center',
      name: 'GaoYaCenter',
      component: GaoYaCenter
    },
    {
      path: '/relixue/login',
      name: 'ReLiXueLogin',
      component: ReLiXueLogin
    },
    {
      path: '/relixue/index',
      name: 'ReLiXueIndex',
      component: ReLiXueIndex
    },
    {
      path: '/relixue/hall',
      name: 'ReLiXueHall',
      component: ReLiXueHall
    },
    {
      path: '/relixue/upgrade',
      name: 'ReLiXueUpgrade',
      component: ReLiXueUpgrade
    },
    {
      path: '/relixue/teach',
      name: 'ReLiXueTeach',
      component: ReLiXueTeach
    },
    {
      path: '/relixue/person',
      name: 'ReLiXuePerson',
      component: ReLiXuePerson
    },
    {
      path: '/relixue/emb01',
      name: 'ReLiXueEMB01',
      component: ReLiXueEMB01
    },
    {
      path: '/relixue/emb02',
      name: 'ReLiXueEMB02',
      component: ReLiXueEMB02
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js